import { __assign, __rest } from "tslib";
import React from 'react';
import { cnTextinput } from '../Textinput';
export var Label = function (_a) {
    var floated = _a.floated, className = _a.className, props = __rest(_a, ["floated", "className"]);
    return (React.createElement("label", __assign({ className: cnTextinput('Label', {
            floated: floated,
        }, [className]) }, props)));
};
